import React from 'react'
import ReactDOM from 'react-dom'
import { compose, pure, branch, renderNothing, withHandlers } from 'recompose'

const enhance = compose(
  branch(
    ({ isOpen }) => isOpen,
    Component => props => {
      // adding this condition so that we can
      // render modals using Bit. this will not
      // affect any other instances of the component
      if (props.bitComposition) {
        const anchor = document.createElement('div')
        anchor.setAttribute('id', 'rootModal')
        document.body.appendChild(anchor)
      }

      // normally we'll just use the rootModal div that's in the index.html
      // but for tests, this doesn't exist so we need to create something
      // to pass to createPortal.
      let rootModal = document.getElementById('rootModal')
      if (!rootModal) {
        rootModal = document.createElement('div')
      }

      return ReactDOM.createPortal(<Component {...props} />, rootModal)
    },
    renderNothing,
  ),
  pure,
  withHandlers({
    handleBackgroundClose: props => e => {
      if (
        e.target.getAttribute('data-testid') === 'info_modalBackground' &&
        props.onClose
      ) {
        props.onClose()
      }
    },
  }),
)

export default enhance
